import { applyCardViewChangesToGrid } from "../../helper/row-sync-card-grid/applyCardViewChangesToGrid";
import XTABLES_ACTION_TYPES from "../xTablesReduxActionTypes";
import { rowFormatterToChangeFieldToHeaderName } from '../../../xTables/components/cardview/helper/computeCardViewHelper'

export const deleteCardWithRollupThunk = (payload) => {
  return (dispatch, getState) => {
    const {
      cardId,
      childRowIds = [],
      dependencyInfo,
      rowsToDisplay,
      headerNameToColObjForCard,
      loggedInUser,
      predecessorcolumn,
      gridChangesPerSaveSession,
    } = payload;


    /* ---------------- IDs to delete ---------------- */
    const deletedIds = new Set([cardId, ...childRowIds]);

    /* ---------------- Dependency Map ---------------- */
    const dependencyMap = {
      [dependencyInfo.rowId]: dependencyInfo,
    };

    /* ---------------- Apply grid + rollup ---------------- */
    const result = applyCardViewChangesToGrid(
      rowsToDisplay,
      dependencyMap,
      headerNameToColObjForCard,
      loggedInUser,
      {
        deletedCardIds: Array.from(deletedIds),
        insertedCards: [],
        updatedCards: [],
      },
      { predecessorColumn: predecessorcolumn }
    );

    /* ---------------- Build gridChanges ---------------- */
    const newGridChanges = {
      add: { ...gridChangesPerSaveSession.add },
      update: { ...gridChangesPerSaveSession.update },
      delete: { ...gridChangesPerSaveSession.delete },
      addedRowsBelowNodeMap: {
        ...gridChangesPerSaveSession.addedRowsBelowNodeMap,
      },
    };

    // DELETE
    result.deletedRows.forEach(row => {
      newGridChanges.delete[row.id] = row;
      delete newGridChanges.add[row.id];
      delete newGridChanges.update[row.id];
    });

    // INSERT
    result.insertedRows.forEach(row => {
      newGridChanges.add[row.id] = row;
    });

    // UPDATE (ROLLUP PARENTS WILL COME HERE)
    result.updatedRows.forEach(row => {
      newGridChanges.update[row.id] = {
        ...(newGridChanges.update[row.id] || {}),
        ...row,
      };
    });

    dispatch({ type: XTABLES_ACTION_TYPES.SET_GRIDCHANGESPERSESSION, gridChangesPerSaveSession: newGridChanges });
    dispatch({ type: XTABLES_ACTION_TYPES.SET_UPDATEROWS, gridRowsForCardSync: result.rows ,recalulateRowIdToIndexMap:true});
    // result.updatedRows are GRID ROWS
    const updatedCards = result.updatedRows.map(row =>
      rowFormatterToChangeFieldToHeaderName(
        row,
        headerNameToColObjForCard
      )
    );

    /* ---------------- Dispatch final result ---------------- */
    dispatch({
      type: XTABLES_ACTION_TYPES.DELETE_CARD_FROM_LANE_SUCCESS,
      payload: {
        deletedCardIds: Array.from(deletedIds),
        updatedRows: updatedCards,
        dependencyMap,
        gridChangesPerSaveSession: newGridChanges,
      },
    });
  };
};
const getLaneKeysFromRow = (row, selectedOption, column) => {
  const value = row[selectedOption];

  if (!value) return ["Uncategorized"];

  // PERSON / ASSIGNEE
  if (column.type === "Assignee" || column.type === "person") {
    try {
      const users = typeof value === "string" ? JSON.parse(value) : value;

      if (!Array.isArray(users) || users.length === 0) {
        return ["Uncategorized"];
      }

      return users.map(u => u);
    } catch (e) {
      return ["Uncategorized"];
    }
  }

  // NORMAL SINGLE VALUE
  return [value];
};
function collapseUpdatedRows(updatedRows) {
  const map = new Map();
  for (const row of updatedRows) {
    map.set(row.id, row);   // overwrites previous → keeps LAST
  }
  return [...map.values()];
}
export const updateCardWithRollupThunk = (payload) => {
  return (dispatch, getState) => {
    const {
      updatedRow,                // updated GRID row (source of truth)
      dependencyInfo,
      rowsToDisplay,
      headerNameToColObjForCard,
      loggedInUser,
      predecessorcolumn,
      gridChangesPerSaveSession,
      selectedOption,            // needed for laneKey calculation
      tempCardData,
       newRowToinsertInGrid,
    } = payload;


    const rowIndexMap = new Map();
    rowsToDisplay.forEach((row, index) => {
      rowIndexMap.set(row.id, index ); // +1 to match UI row numbering
    });
    
    /* ---------------- Dependency Map ---------------- */
    const dependencyMap = {

      [dependencyInfo.rowId]: dependencyInfo,
    };

    /* ---------------- Apply grid + rollup ---------------- */
    const result = applyCardViewChangesToGrid(
      rowsToDisplay,
      dependencyMap,
      headerNameToColObjForCard,
      loggedInUser,
      {
        deletedCardIds: [],
        insertedCards: [],
        updatedCards: [updatedRow],
      },
      { predecessorColumn: predecessorcolumn }
    );

    /* ---------------- Build gridChangesPerSaveSession ---------------- */
    const newGridChanges = {
      add: { ...gridChangesPerSaveSession.add },
      update: { ...gridChangesPerSaveSession.update },
      delete: { ...gridChangesPerSaveSession.delete },
      addedRowsBelowNodeMap: {
        ...gridChangesPerSaveSession.addedRowsBelowNodeMap,
      },
    };

    // DELETE rows
    result.deletedRows.forEach(row => {
      newGridChanges.delete[row.id] = row;
      delete newGridChanges.add[row.id];
      delete newGridChanges.update[row.id];
    });

    // INSERT rows
    result.insertedRows.forEach(row => {
      newGridChanges.add[row.id] = row;
    });
    if (newRowToinsertInGrid?.length) {
  
      let addedRows = newRowToinsertInGrid
      let belowNodeId="none"
      if (belowNodeId) {
          addedRows.forEach(row => {
              if (newGridChanges.addedRowsBelowNodeMap && newGridChanges.addedRowsBelowNodeMap[belowNodeId]) 
                  belowNodeId = newGridChanges.addedRowsBelowNodeMap[belowNodeId]
                  let allNewRowsAboveThisNode = newGridChanges.add[belowNodeId] || []
                   allNewRowsAboveThisNode.unshift(row)
                   newGridChanges.add[belowNodeId] = allNewRowsAboveThisNode
                  newGridChanges.addedRowsBelowNodeMap[row.id] = belowNodeId
          })
      }
  }

    // UPDATE rows (rollup parents + updated row)
    result.updatedRows.forEach(row => {
      newGridChanges.update[row.id] = {
        ...(newGridChanges.update[row.id] || {}),
        ...row,
      };
    });

    /* ---------------- Dispatch grid changes updates ---------------- */
    dispatch({
      type: XTABLES_ACTION_TYPES.SET_GRIDCHANGESPERSESSION,
      gridChangesPerSaveSession: newGridChanges,
    });

    dispatch({
      type: XTABLES_ACTION_TYPES.SET_UPDATEROWS,
      gridRowsForCardSync: result.rows,
      recalulateRowIdToIndexMap:newRowToinsertInGrid?.length?true:false
    });

    /* ---------------- Convert updatedRows (grid rows) to card format ---------------- */
    const column = headerNameToColObjForCard[selectedOption];
    const finalRows = collapseUpdatedRows(result.updatedRows);
// -------------------------------
// Step 1: Collect l_id → rowId
// -------------------------------
const lIdToRowId = new Map();

rowsToDisplay.forEach(row => {
  if (!row || !row.id || typeof row.l_id !== "string") return;
  lIdToRowId.set(row.l_id, row.id);
});

// -------------------------------
// Step 2: Find parent l_ids
// -------------------------------
const parentLIdSet = new Set();

rowsToDisplay.forEach(row => {
  if (!row || typeof row.l_id !== "string") return;

  const parts = row.l_id.split(".");
  if (parts.length > 1) {
    for (let i = 1; i < parts.length; i++) {
      parentLIdSet.add(parts.slice(0, i).join("."));
    }
  }
});

// -------------------------------
// Step 3: Parent → child ids map
// -------------------------------
const parentToChildIdsMap = new Map();

parentLIdSet.forEach(parentLId => {
  const children = rowsToDisplay
    .filter(r =>
      r &&
      typeof r.l_id === "string" &&
      r.l_id.startsWith(parentLId + ".") &&
      r.id
    )
    .map(r => r.id);

  parentToChildIdsMap.set(parentLId, children);
});

// -------------------------------
// Hierarchy helper (null-safe)
// -------------------------------
const getHierarchyInfo = row => {
  if (!row || typeof row.l_id !== "string") {
    return {
      isParent: false,
      isChild: false,
      isRoot: true,
      childRowIds: []
    };
  }

  const parts = row.l_id.split(".");
  const isChild = parts.length > 1;
  const isParent = parentLIdSet.has(row.l_id);
  const isRoot = !isChild;

  return {
    isParent,
    isChild,
    isRoot,
    childRowIds: isParent
      ? parentToChildIdsMap.get(row.l_id) || []
      : []
  };
};

    const updatedCards = finalRows.flatMap(row => {
      const baseCard = row.id == tempCardData.id ? tempCardData : rowFormatterToChangeFieldToHeaderName(
        row,
        headerNameToColObjForCard
      );

      const laneKeys = getLaneKeysFromRow(row, selectedOption, column);
      const rowIndex = rowIndexMap.get(row.id) ?? 0;

      return laneKeys.map(laneKey => ({
        ...baseCard,
        lane_id: `${row.id}__${laneKey}`,   // ✅ UNIQUE CARD ID
        rowIndex,       
        laneKey: laneKey || "Uncategorized",
        hierarchy: getHierarchyInfo(row),
      }));
      
    });


    /* ---------------- Dispatch card view update ---------------- */
    dispatch({
      type: XTABLES_ACTION_TYPES.UPDATE_CARD_IN_LANE_SUCCESS,
      payload: {
        updatedCards,
        dependencyMap,
        gridChangesPerSaveSession: newGridChanges,
        groupByColumnType: headerNameToColObjForCard[selectedOption].type
      },
    });
  };
};

const parseUsers = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const buildUpdatedCard = ({ baseCard, cardHeaderName, users }) => {
  const cloned = JSON.parse(JSON.stringify(baseCard));
  cloned[cardHeaderName] = users.map(u => u.username).join(", ");
  return cloned;
};

export const moveCardBetweenLanesThunk = ({
  cardId,
  sourceLaneKey,
  destLaneKey,
  destIndex,
  selectedOption,
  lanes,
  headerNameToColObjForCard,
  overriddenValue,
  row,
  gridChangesPerSaveSession,
  gridRowsForCardSync
}) => (dispatch) => {

  const columnType = headerNameToColObjForCard[selectedOption]?.type;
  const cardHeaderName =
    headerNameToColObjForCard[selectedOption].headerName;

  /** 🔴 OVERRIDE FLOW (ONLY when overriddenValue exists) */
  if (
    overriddenValue &&
    (columnType === "Assignee" || columnType === "person")
  ) {
    const users = parseUsers(overriddenValue);

    // Update row source of truth
    row[selectedOption] = overriddenValue;
    row[selectedOption+'_es'] = {value:overriddenValue};
    // Base card reference (before mutation)
    const baseCard = lanes
      .flatMap(l => l.cards)
      .find(card => card.id === cardId);

    if (!baseCard) return;

    // 1️⃣ Remove card from ALL lanes
    const newLanes = lanes.map(lane => ({
      ...lane,
      cards: lane.cards.filter(card => card.id !== cardId),
    }));

    // 2️⃣ Insert updated card into ONLY override lanes
    users.forEach((user, index) => {
      const laneIndex = newLanes.findIndex(
        lane => lane.user?.username === user.username
      );

      if (laneIndex === -1) return;

      const updatedCard = buildUpdatedCard({
        baseCard,
        cardHeaderName,
        users,
      });

      const cards = [...newLanes[laneIndex].cards];
      cards.splice(index === 0 ? destIndex : cards.length, 0, updatedCard);

      newLanes[laneIndex] = {
        ...newLanes[laneIndex],
        cards,
      };
    });

    dispatch({
      type: XTABLES_ACTION_TYPES.INIT_CARD_VIEW,
      payload: newLanes,
    });
    const newGridChanges = {
      add: { ...gridChangesPerSaveSession.add },
      update: { ...gridChangesPerSaveSession.update },
      delete: { ...gridChangesPerSaveSession.delete },
      addedRowsBelowNodeMap: {
        ...gridChangesPerSaveSession.addedRowsBelowNodeMap,
      },
    };
    newGridChanges.update[row.id] = {
      ...(newGridChanges.update[row.id] || {}),
      ...row,
    };
    let workingRows = [...gridRowsForCardSync];
    const updatedRowMap = new Map();
   
      if (row.id) {
        updatedRowMap.set(row.id, row);
    };
  
    let updatedRows = [];
  
    workingRows = workingRows.map(row => {
      const update = updatedRowMap.get(row.id);
      if (!update) return row;
  
      const updatedRow = { ...row, ...update };
      updatedRows.push(updatedRow);
      return updatedRow;
    });
     /* ---------------- Dispatch grid changes updates ---------------- */
     dispatch({
      type: XTABLES_ACTION_TYPES.SET_GRIDCHANGESPERSESSION,
      gridChangesPerSaveSession: newGridChanges,
    });
    dispatch({
      type: XTABLES_ACTION_TYPES.SET_UPDATEROWS,
      gridRowsForCardSync: workingRows,
    });

    dispatch({ type: XTABLES_ACTION_TYPES.ENABLE_SAVE_BUTTON });
    return;
  }

  /** 🟢 NORMAL DRAG FLOW (NO override → DO NOT clean other lanes) */

  const sourceLaneIndex = lanes.findIndex(
    lane => (lane.user?.username || "Uncategorized") === sourceLaneKey
  );
  const destLaneIndex = lanes.findIndex(
    lane => (lane.user?.username || "Uncategorized") === destLaneKey
  );

  if (sourceLaneIndex === -1) return;

  const newLanes = [...lanes];
  const sourceCards = [...newLanes[sourceLaneIndex].cards];

  const cardIndex = sourceCards.findIndex(card => card.id === cardId);
  if (cardIndex === -1) return;

  const [movedCard] = sourceCards.splice(cardIndex, 1);
  const destUser = lanes[destLaneIndex].user;
  const isAssigneeCol = headerNameToColObjForCard[selectedOption].type === 'Assignee' || headerNameToColObjForCard[selectedOption].type === 'person';
  const assigneeValue = destUser.username === "Uncategorized" ? '' : isAssigneeCol ? JSON.stringify(Array.isArray(destUser) ? destUser : [destUser]) : destUser.username;
  row[selectedOption] = assigneeValue;
  row[selectedOption+'_es'] = { value: assigneeValue };
  movedCard[cardHeaderName] = lanes[destLaneIndex].user.username === "Uncategorized" ? '' :  lanes[destLaneIndex].user.username // or build user object as needed

  newLanes[sourceLaneIndex] = {
    ...newLanes[sourceLaneIndex],
    cards: sourceCards,
  };


  if (destLaneIndex === -1) return;

  const destCards = [...newLanes[destLaneIndex].cards];
  destCards.splice(destIndex, 0, movedCard);

  newLanes[destLaneIndex] = {
    ...newLanes[destLaneIndex],
    cards: destCards,
  };

  dispatch({
    type: XTABLES_ACTION_TYPES.INIT_CARD_VIEW,
    payload: newLanes,
  });
  const newGridChanges = {
    add: { ...gridChangesPerSaveSession.add },
    update: { ...gridChangesPerSaveSession.update },
    delete: { ...gridChangesPerSaveSession.delete },
    addedRowsBelowNodeMap: {
      ...gridChangesPerSaveSession.addedRowsBelowNodeMap,
    },
  };
  newGridChanges.update[row.id] = {
    ...(newGridChanges.update[row.id] || {}),
    ...row,
  };
  let workingRows = [...gridRowsForCardSync];
  const updatedRowMap = new Map();
 
    if (row.id) {
      updatedRowMap.set(row.id, row);
  };

  let updatedRows = [];

  workingRows = workingRows.map(row => {
    const update = updatedRowMap.get(row.id);
    if (!update) return row;

    const updatedRow = { ...row, ...update };
    updatedRows.push(updatedRow);
    return updatedRow;
  });
   /* ---------------- Dispatch grid changes updates ---------------- */
   dispatch({
    type: XTABLES_ACTION_TYPES.SET_GRIDCHANGESPERSESSION,
    gridChangesPerSaveSession: newGridChanges,
  });
  dispatch({
    type: XTABLES_ACTION_TYPES.SET_UPDATEROWS,
    gridRowsForCardSync: workingRows,
  });

  dispatch({ type: XTABLES_ACTION_TYPES.ENABLE_SAVE_BUTTON });
};



export const syncGridRowsToCardView = (gridRef, dispatch,recalulateRowIdToIndexMap) => {
  if (!gridRef?.current?.api) return;

  const rowData = [];
  gridRef.current.api.forEachNode((node) => {
    if (node?.data) {
      rowData.push(node.data);
    }
  });

  dispatch({
    type: XTABLES_ACTION_TYPES.SET_UPDATEROWS,
    gridRowsForCardSync: rowData,
    recalulateRowIdToIndexMap:recalulateRowIdToIndexMap
  });
};
let syncTimer = null;

export const scheduleGridToCardSync = (gridRef, dispatch,recalulateRowIdToIndexMap, delay = 100) => {
  if (!gridRef?.current) return;

  // cancel previous scheduled sync
  if (syncTimer) {
    clearTimeout(syncTimer);
  }

  syncTimer = setTimeout(() => {
    syncTimer = null;
    syncGridRowsToCardView(gridRef, dispatch,recalulateRowIdToIndexMap);
  }, delay);
};